import {
  MyChartOpenSchedulingConfig,
  ProviderMatchProviderV9
} from '@kyruus/types';
import { validateMyChartOpenSchedulingConfiguration } from './validation';
import React from 'react';
import {
  buildMyChartOpenSchedulingWidgetUrl,
  convertOverrides,
  getProviderIdForOpenScheduling,
  getVisitTypesFromProviderForOpenScheduling,
  MyChartOpenSchedulingUrlOptions
} from './utilities';
import { ConfigurationIssues } from '../ConfigurationIssues/ConfigurationIssues';
import { AppointmentsHeading, OpenSchedulingIFrame } from './styles';
import CardContainer from '../CardContainer/card-container';
import { WrappedComponentProps, injectIntl } from '@kyruus/intl';
import messages from '../../lib/messages';
import { ValidationIssue } from '../../types';

export interface MyChartOpenSchedulingWidgetProps {
  openSchedulingConfig?: MyChartOpenSchedulingConfig;
  provider: ProviderMatchProviderV9;
}

function MyChartOpenSchedulingWidget(
  props: MyChartOpenSchedulingWidgetProps & WrappedComponentProps
) {
  const openSchedulingConfig = props.openSchedulingConfig;

  if (!(openSchedulingConfig?.enabled ?? false)) {
    return <></>;
  }

  const openSchedulingConfigValidationIssues: ValidationIssue[] = [];

  if (
    !validateMyChartOpenSchedulingConfiguration(
      openSchedulingConfig,
      openSchedulingConfigValidationIssues
    )
  ) {
    return (
      <ConfigurationIssues issues={openSchedulingConfigValidationIssues} />
    );
  }

  const visitTypes = getVisitTypesFromProviderForOpenScheduling(
    openSchedulingConfig,
    props.provider
  );

  const providerId = getProviderIdForOpenScheduling(props.provider);

  if (!providerId) {
    return <></>;
  }

  const options: MyChartOpenSchedulingUrlOptions = {
    url: openSchedulingConfig.url,
    apiKey: openSchedulingConfig.api_key,
    widgetId: openSchedulingConfig.widget_id,
    providerId,
    visitTypes
  };

  if (openSchedulingConfig.overrides) {
    options.overrides = convertOverrides(openSchedulingConfig.overrides);
  }

  const embeddedUrl = buildMyChartOpenSchedulingWidgetUrl(options);

  return (
    <section aria-labelledby="ProviderAppointmentsHeading">
      <CardContainer>
        <AppointmentsHeading id="ProviderAppointmentsHeading">
          {props.intl.formatMessage(messages.profileAppointmentsHeader)}
        </AppointmentsHeading>
        <section
          aria-label={props.intl.formatMessage(
            messages.openSchedulingWidgetLabel
          )}
        >
          <OpenSchedulingIFrame src={embeddedUrl}></OpenSchedulingIFrame>
        </section>
      </CardContainer>
    </section>
  );
}

const MyChartOpenSchedulingEmbeddedWithIntl = injectIntl(
  MyChartOpenSchedulingWidget
);

export { MyChartOpenSchedulingEmbeddedWithIntl as MyChartOpenSchedulingWidget };
